// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--Io8Gt","label":"a10a3f92e9--label--zUI_z"};